import { useState, useEffect } from 'react';
import { Checkbox } from '@repo/design-system-kit';
import { setConsent, CONSENT_STORAGE_KEY } from '../../utils/marketing-consent-storage';

export interface ConsentCheckboxProps {
  children: React.ReactNode;
  className?: string;
  onChange?: (isChecked: boolean) => void;
}

export function ConsentCheckbox({
  children,
  className,
  onChange,
}: ConsentCheckboxProps): React.ReactElement {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    setConsent(false);
  }, []);

  const handleChange = (checked: boolean): void => {
    setIsChecked(checked);
    setConsent(checked);
    onChange?.(checked);
  };

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === CONSENT_STORAGE_KEY) {
        const newValue = event.newValue === 'true';
        if (newValue !== isChecked) {
          setIsChecked(newValue);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [isChecked]);

  return (
    <div className={className} data-test-invite-consent-checkbox>
      <Checkbox data-test-consent-checkbox isSelected={isChecked} onChange={handleChange}>
        {children}
      </Checkbox>
    </div>
  );
}
